/**
 * English - Common / Shared translations
 */
export const common = {
  loading: 'Loading...',
  error: 'An error occurred',
  retry: 'Retry',
  save: 'Save',
  saving: 'Saving...',
  saved: 'Saved',
  saveProgress: 'Save Progress',
  saveFailed: 'Save failed',
  cancel: 'Cancel',
  delete: 'Delete',
  deleting: 'Deleting...',
  edit: 'Edit',
  show: 'Show',
  hide: 'Hide',
  view: 'View',
  search: 'Search',
  filter: 'Filter',
  clear: 'Clear',
  submit: 'Submit',
  confirm: 'Confirm',
  back: 'Back',
  next: 'Next',
  previous: 'Previous',
  close: 'Close',
  yes: 'Yes',
  no: 'No',
  ok: 'OK',
  required: 'Required',
  optional: 'Optional',
  noResults: 'No results found',
  showMore: 'Show more',
  showLess: 'Show less',
  continue: 'Continue',
  getStarted: 'Get Started',
  learnMore: 'Learn More',
  viewAll: 'View All',
  seeMore: 'See More',
  apply: 'Apply',
  reset: 'Reset',
  refresh: 'Refresh',
  download: 'Download',
  upload: 'Upload',
  remove: 'Remove',
  add: 'Add',
  create: 'Create',
  update: 'Update',
  select: 'Select',
  selected: 'Selected',
  all: 'All',
  none: 'None',
  or: 'or',
  of: 'of',
  and: 'and',
  popular: 'Popular',
  clearAll: 'Clear all',
  searchPlaceholder: 'Search...',
  noOptionsFound: 'No options found',
  selectedCount: '{count} / {max} selected',
  questionsFound: '{count} questions found',
  secure: 'SECURE',
  mo: 'mo',


  // ── Missing keys added by translation scan ──
  actions: 'Actions',
  backToDashboard: 'Back to Dashboard',
  date: 'Date',
  replace: 'Replace',
  returnToDashboard: 'Return to Dashboard',
  unknown: 'Unknown',

  // ── Hardcoded strings (auto-generated) ──
    anonymousBank: 'Bank #{n}',
  hardcoded: {
    somethingWentWrong: 'Something went wrong',
    anUnexpectedErrorOccurredOur: 'An unexpected error occurred. Our team has been notified automatically.',
    markAllRead: 'Mark all read',
    viewAllNotifications: 'View all notifications',
    memberAreaUnavailable: 'Member Area Unavailable',
    returnToHomePage: 'Return to Home Page',
    addAnExtraLayerOf: 'Add an extra layer of security using Google Authenticator',
    scanThisQrCodeWith: 'Scan this QR code with your authenticator app',
    whatYouNeedForQualification: 'What you need for Qualification and Closing',
    requirementsByStage: 'Requirements by stage',
    perspectiveSessionExpired: 'Perspective session expired.',
    allActionsAreDisabledBackend: 'All actions are disabled — backend enforced',
    createAFreeAccountTo: 'Create a free account to ask the advisor. Your question will be submitted automatically after sign-up.',
    askAnyQuestionAboutYour: 'Ask any question about your mortgage options. Your profile information will be shared with the advisor automatically.',
    youCanAskInAny: 'You can ask in any language — the response will be in the same language as your question.',
    startAFormalApplicationFree: 'Start a formal application — free',
    askAnotherQuestion: 'Ask another question',
    signUpToAsk: 'Sign up to ask',
    yourProfileDataIsSent: 'Your profile data is sent to the AI to provide a personalised response.',
    notFinancialAdvice: 'Not financial advice.',
    backToHipotechHome: 'Back to HipoTech home',
      pageNotFound: 'Page not found',
      itMayHaveBeenMoved: 'It may have been moved, deleted, or you may have mistyped the address.',
      goToHome: 'Go to home',
      egWhichBankGivesMe: 'e.g. Which bank gives me the lowest total interest if I plan to pay off within 2 years?',
      secureDocumentPortal: 'Secure Document Portal',
      ifYouBelieveThisIs: 'If you believe this is an error, please contact the sender.',
      yourDocumentHasBeenDownloaded: 'Your document has been downloaded successfully.',
      secureDocumentDownload: 'Secure Document Download',
      theAccessCodeWasSent: 'The access code was sent to you in the email notification',
      thisDocumentIsProtectedWith: 'This document is protected with end-to-end encryption.',
      theAccessCodeEnsuresOnly: 'The access code ensures only authorized recipients can view the contents.',
      learnHowWeProtectYour: 'Learn how we protect your sensitive information with industry-leading security.',
  },
} as const;